import { PointHistories } from "repositories";
import { useSWRInfiniteWithScroller } from "shared/hooks/useSWRInfiniteWithScroller";
import { InfiniteLoadingReturn, PointHistoriesResponse } from "shared/types";

interface UsePointHistoriesProps {
  perPage?: number;
}

export const usePointHistories = ({
  perPage = 30,
}: UsePointHistoriesProps): InfiniteLoadingReturn<PointHistoriesResponse> => {
  return useSWRInfiniteWithScroller((pageIndex, previousPageData) => {
    if (previousPageData && !previousPageData.pointHistories.length)
      return null;
    return `/me/point_histories?page=${pageIndex + 1}&limit=${perPage}`;
  }, PointHistories.index);
};
